import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/multilevel_menu_example',
  component: Layout,
  name: 'multilevelMenuExample',
  meta: {
    title: $t('route.multimenu.root'),
    icon: 'i-heroicons-solid:menu-alt-3',
    maximize: true, // 设置此属性后，访问该路由时会自动最大化页面（隐藏头部、侧边栏等）兼容旧后台 iframe 嵌入场景
  },
  children: [
    {
      path: 'page',
      name: 'multilevelMenuExample1',
      component: () => import('@/views/multilevel_menu_example/page.vue'),
      meta: {
        title: $t('route.multimenu.page'),
      },
    },
  ],
}

export default routes
